export const SWITCH_ACCOUNT_DENIED_MESSAGE = "Switch Account Denied";
export const SWITCH_ACCOUNT_DENIED_START_SECONDS = 10;

export type SwitchAccountDeniedState = {
  isOpen: boolean;
  secondsRemaining: number;
  signOutStarted: boolean;
};

export type SwitchAccountDeniedHandlers = {
  triggerModal: () => void;
  signOut: () => void;
  redirectMaintenance: () => void;
};

type GraphQlGatewayResponse = {
  ResponseCode?: number;
  ErrorMessage?: string;
};

export const createSwitchAccountDeniedState = (): SwitchAccountDeniedState => ({
  isOpen: false,
  secondsRemaining: SWITCH_ACCOUNT_DENIED_START_SECONDS,
  signOutStarted: false,
});

export const isSwitchAccountDeniedResponse = (bodyText?: string) => {
  if (!bodyText) {
    return false;
  }

  try {
    const body = JSON.parse(bodyText) as GraphQlGatewayResponse;

    return body?.ResponseCode === 401 && body?.ErrorMessage === SWITCH_ACCOUNT_DENIED_MESSAGE;
  } catch {
    return false;
  }
};

export const openSwitchAccountDeniedState = (current: SwitchAccountDeniedState) => {
  if (current.isOpen || current.signOutStarted) {
    return current;
  }

  return {
    isOpen: true,
    secondsRemaining: SWITCH_ACCOUNT_DENIED_START_SECONDS,
    signOutStarted: false,
  };
};

export const advanceSwitchAccountDeniedState = (current: SwitchAccountDeniedState) => {
  if (!current.isOpen || current.signOutStarted || current.secondsRemaining <= 0) {
    return current;
  }

  return {
    ...current,
    secondsRemaining: current.secondsRemaining - 1,
  };
};

export const markSwitchAccountDeniedSignOutStarted = (current: SwitchAccountDeniedState) => {
  if (current.signOutStarted) {
    return current;
  }

  return {
    ...current,
    signOutStarted: true,
  };
};

export const shouldTriggerSwitchAccountDeniedSignOut = (current: SwitchAccountDeniedState) => {
  return current.isOpen && !current.signOutStarted && current.secondsRemaining <= 0;
};

export const handleSwitchAccountDeniedError = (
  bodyText: string | undefined,
  operationName: string | undefined,
  handlers: SwitchAccountDeniedHandlers
) => {
  if (!bodyText) {
    return false;
  }

  try {
    const body = JSON.parse(bodyText) as GraphQlGatewayResponse;

    if (body?.ResponseCode !== 401) {
      return false;
    }

    if (operationName === "getMaintenanceStatus") {
      handlers.redirectMaintenance();
      return true;
    }

    if (isSwitchAccountDeniedResponse(bodyText)) {
      handlers.triggerModal();
      return true;
    }

    handlers.signOut();
    return true;
  } catch {
    return false;
  }
};